//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const bgClasses = {
  dark: 'bg-blue-900',
  medium: 'bg-blue-500',
  light: 'bg-blue-200',
  tint: 'bg-blue-100',
  transparent: 'bg-transparent',
  white: 'bg-white',
  intervene: 'bg-spr-intervene',
  watch: 'bg-spr-watch',
  reinforce: 'bg-spr-reinforce',
  model: 'bg-spr-model',
  gray: 'bg-gray-300',
  mediumgray: 'bg-gray-600'
}

const bgHoverClasses = {
  dark: 'bg-indigo-900',
  medium: 'bg-indigo-600',
  light: 'bg-indigo-100',
  tint: 'bg-indigo-100',
  transparent: 'bg-transparent',
  white: 'bg-gray-200',
  intervene: 'bg-spr-intervene',
  watch: 'bg-spr-watch',
  reinforce: 'bg-spr-reinforce',
  model: 'bg-spr-model',
  gray: 'bg-gray-400',
  mediumgray: 'bg-gray-700'
}

const textClasses = {
  dark: 'text-white',
  medium: 'text-white',
  light: 'text-blue-900',
  tint: 'text-blue-900',
  transparent: 'text-blue-900',
  white: 'text-blue-900',
  intervene: 'text-white',
  watch: 'text-white',
  reinforce: 'text-white',
  model: 'text-white',
  red: 'text-spr-intervene',
  mediumgray: 'text-white'
}
const sizeClasses = {
  extralarge: 'text-4xl sm:text-6xl',
  large: 'text-4xl',
  mediumlarge: 'text-2xl',
  medium: 'text-xl',
  small: 'text-base',
  extrasmall: 'text-sm',
  auto: ''
}

export default {
  props: {
    selected: {
      type: Boolean,
      required: false,
      default: false
    },
    /** The default (unselected color) */
    color: {
      type: String,
      required: false,
      default: 'medium'
    },
    tight: {
      type: Boolean,
      required: false,
      default: false
    },
    unrounded: {
      type: Boolean,
      required: false,
      default: false
    },
    rotateText: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'small'
    }
  },
  computed: {
    sizeClass() {
      return sizeClasses[this.size]
    },
    bgClass() {
      return bgClasses[this.color]
    },
    bgHoverClass() {
      return bgHoverClasses[this.color]
    },
    textClass() {
      return textClasses[this.color]
    }
  }
}
